import React from "react";
import { Form } from "antd";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { MAX_MINUTES } from "constants/criteria";
import { PriorityField, SliderIdealMaxInputField } from "components/Fields";
import { createHistogramSteps, getInitialRangePriorityValues, onCriteriaRangeFormFinish } from "utils/helpers/criteriaHelper";
import "../../styles.scss";

const DEFAULT_VALUES = {
  min: 0,
  max: MAX_MINUTES,
  ideal: 0,
  step: 5,
}

const HISTOGRAM_STEPS = createHistogramSteps(DEFAULT_VALUES.min, DEFAULT_VALUES.max * 60, DEFAULT_VALUES.step * 60);

const ParksForm = ({ dataKind, formName, initialData, kind, withPriority, onSubmitForm }) => {
  const [form] = Form.useForm();

  const initialValues = getInitialRangePriorityValues(DEFAULT_VALUES, initialData, true, false, withPriority);

  const onFinish = values => onCriteriaRangeFormFinish(kind, values, withPriority, onSubmitForm);

  return (
    <Form
      form={form}
      initialValues={initialValues}
      name={formName}
      onFinish={onFinish}
    >
      <Form.Item name="range">
        <SliderIdealMaxInputField
          dataKind={dataKind}
          kind={kind}
          form={form}
          min={DEFAULT_VALUES.min}
          max={DEFAULT_VALUES.max}
          step={DEFAULT_VALUES.step}
          histogramSteps={HISTOGRAM_STEPS}
          maxInputValue={MAX_MINUTES}
          invertTrack
          idealMessage={<FormattedMessage id="dashboard.form.targetMinutesByDrivingAway" />}
          maxMessage={<FormattedMessage id="dashboard.form.maximumMinutesByDrivingAway" />}
        />
      </Form.Item>
      {withPriority && (
        <Form.Item name="priority">
          <PriorityField />
        </Form.Item>
      )}
    </Form>
  );
};

ParksForm.propTypes = {
  dataKind: PropTypes.string,
  formName: PropTypes.string,
  initialData: PropTypes.object,
  kind: PropTypes.string,
  withPriority: PropTypes.string,
  onSubmitForm: PropTypes.func,
};

export default ParksForm;
